import { Transaction, TransactionCtx } from "../../types/transaction";
import { generateAPI } from "../api.generator";

export const getAllInitiatorsTransactions = generateAPI<
  {
    query: {
      transactionCtx: TransactionCtx;
      page: number;
    }
  }
, 
{
  transactionCount: number;
  transactionList: Transaction[];
}>("get", "transactions/all");
